import React from 'react';

const SelectableCssVariablesImport = ({ variables, component }) => {
	const [varToRender, setVarToRender] = React.useState([]);
	const [scopedClasses, setScopedClasses] = React.useState([]);

	React.useEffect(() => {
		const cssArray = [];
		variables?.forEach((variableType) => {
			variableType?.list.forEach((color) => {
				if (isNaN(color.from)) {
					cssArray.push(`${color.to}: var(${color.from})`);
				} else {
					cssArray.push(`${color.to}: ${color.from}`);
				}
			});
		});
		setVarToRender(cssArray);
	}, [variables]);
	//trocando ...variables para variables para remover o seguinte erro
	//The final argument passed to useEffect changed size between renders. The order and size of this array must remain constant.

	React.useEffect(() => {
		//fix for visibility layout
		if (component?.componentName === 'VisibilityLayout') {
			const childCompId = component?.childrenComponents?.[0]?.componentId;
			if (childCompId) {
				setScopedClasses([`[data-selection="${childCompId}"]`, `[data-rbd-draggable-id="${childCompId}"]`]);
			}
		} else if (component?.componentId) {
			setScopedClasses([
				`[data-selection="${component.componentId}"]`,
				`[data-rbd-draggable-id="${component.componentId}"]`,
			]);
		}
	}, [component]);
	if (!varToRender?.length) return <div />;
	//colocar aqui os componentes que usam portal do chakra
	//arrumar dps pq essa regra n funciona parar todos os casos, faz ter exceçoes demais

	//tirei o flexRow daqui, não sei o que afeta
	const portalComponents = [
		'ModalTrigger',
		'Minicart',
		'MinicartFixed',
		'SellerTable',
		'HeaderMobile',
		'ModalNewsletter',
	];
	if (portalComponents.includes(component.componentName) || portalComponents.includes(component.componentGroup)) {
		return (
			<style>{`.canvas,.canvas-iframe{
            ${varToRender.join(';')}
        }`}</style>
		);
	}
	return (
		<style>
			{`::before,::after,${scopedClasses?.map((blockClass) => blockClass || '*').join(',')}{
            ${varToRender.join(';')}
        }`}{' '}
		</style>
	);
};

export default SelectableCssVariablesImport;
